import http from '../../../http/http';

const state = {
    minbestand: [],
    bestand: [],
    neueBestellung: [],
    bestellteArt: [],
    bestellFiles: []
};

const getters = {
    minbestand: (state) => state.minbestand,
    bestand: (state) => state.bestand,
    neueBestellung: (state) => state.neueBestellung,
    bestellteArt: (state) => state.bestellteArt,
    bestellFiles: (state) => state.bestellFiles

};

const mutations = {
    minbestand: (state, payload) => {
        state.minbestand = payload;
    },
    bestand: (state, payload) => {
        state.bestand = payload;
    },
    neueBestellung: (state, payload) => {
        state.neueBestellung = payload;
    },
    bestellteArt: (state, payload) => {
        state.bestellteArt = payload;
    },
    bestellFiles: (state, payload) => {
        state.bestellFiles = payload;
    }
};

const actions = {

    minbestand: ({ commit }, payload) => {
        var data = {
            stao: payload.stao
        }

        http.post('/getArtUnderMin', data)
            .then((response) => {
                commit('minbestand', response.data);
            });
    },

    downloadMinBestand: ({ state }, payload) => {
        var data = {
            stao: payload.stao,
            list: state.minbestand
        };

        http.post('/makeFileArtUnderMin', data)
            .then((response) => {
                var url = payload.url + '/downloadFileArtUnderMin/' + response.data;

                window.location.assign(url);
            });
    },

    createQR: ({}, payload) => {
        var data = {
            stao: payload.stao,
            list: payload.list
        }

        http.post('/createArtQR', data)
            .then((response) => {
                var url = payload.url + '/downloadQRZip/' + response.data;

                window.location.assign(url);
            });
    },

    uploadFileNewArt: ({ dispatch }, payload) => {
        // make sure file size isn't too big
        if (payload.file.size > 2000000) {
            // push the msg to the notifications
            dispatch('notifications/notification', {
                msg: 'File zu gross. Bitte unter 2.0Mb halten.',
                error: true,
                time: 5000
            }, { root: true });
        } else {
            var data = new FormData();

            data.append('stao', payload.stao);
            data.append('delimiter', payload.delimiter);
            data.append('file', payload.file);

            http.post('/uploadLagerNewArt', data)
                .then((response) => {
                    console.log(response);

                    // push the msg to the notifications
                    dispatch('notifications/notification', {
                        msg: 'Neue Art Hinzugefügt',
                        error: false,
                        time: 2000
                    }, { root: true });
                });
        }
    },

    uploadFileStorage: ({ dispatch }, payload) => {
        // make sure file size isn't too big
        if (payload.file.size > 2000000) {
            // push the msg to the notifications
            dispatch('notifications/notification', {
                msg: 'File zu gross. Bitte unter 2.0Mb halten.',
                error: true,
                time: 5000
            }, { root: true });
        } else {
            var data = new FormData();

            data.append('file', payload.file, 'test.csv');
            data.append('stao', payload.stao);
            data.append('delimiter', payload.delimiter);

            http.post('/uploadLagerStorage', data)
                .then((response) => {
                    // push the msg to the notifications
                    dispatch('notifications/notification', {
                        msg: 'Art-Update Erfolgreich',
                        error: false,
                        time: 2000
                    }, { root: true });

                    // if there is a file to get
                    if (response.data !== '') {
                        // get it

                        var url = payload.url + '/downloadFileNewArt/' + response.data;

                        window.location.assign(url);
                    }
                });
        }
    },

    bestand: ({ commit }, payload) => {
        http.post('/getAllArtFromStao', payload)
            .then((response) => {
                commit('bestand', response.data);
            });
    },

    neueBestellung: ({ commit }, payload) => {
        http.post('/getNeueBestellung', payload)
            .then((response) => {
                // add the checked atribute to the objects
                for (var i = 0; i < response.data.length; i++) {
                    response.data[i].checked = true;
                }

                commit('neueBestellung', response.data);
            });
    },

    bestellungBuchen: ({ commit }, payload) => {
        var data = {
            stao: parseInt(payload.stao),
            delimiter: payload.delimiter,
            art: [],
            userName: payload.userName,
            userId: payload.userId,
            url: payload.url
        }

        // go through the payload and only add the ones that are checked for buchung
        for (var i = 0; i < payload.art.length; i++) {
            if (payload.art[i].checked === true) {
                data.art.push(payload.art[i]);
            }
        }

        http.post('/bestellungBuchen', data)
            .then((response) => {
                // download the file
                var url = payload.url + '/downloadFileBestellung/' + response.data;

                window.location.assign(url);

                // router.go();
            })
    },

    bestellteArt: ({ commit }, payload) => {
        http.post('/getAllBestellt', payload)
            .then((response) => {
                // add an unchangable valuestandOrte
                for (let i = 0; i < response.data.length; i++) {
                    response.data[i].gekommen = 0;
                    response.data[i].checked = false;
                }

                commit('bestellteArt', response.data);
            });
    },

    bestellUpdate: ({ state }) => {
        let data = [];
        let bestand = 0;

        for (let i = 0; i < state.bestellteArt.length; i++) {
            console.log(state.bestellteArt);

            // check if it is a packung or not
            // if(state.bestellteArt[i].packung){
            bestand = (parseInt(state.bestellteArt[i].besMax) + parseInt(state.bestellteArt[i].gekommen)); // +parseInt(state.bestellteArt[i].eingetroffen)),
            // }else{
            //     bestand = parseInt(state.bestellteArt[i].besMax)+(parseInt(state.bestellteArt[i].gekommen)*parseInt(state.bestellteArt[i].StkProEinheit));
            // }

            let stuff = {
                artId: state.bestellteArt[i].artId,
                bestellungenId: state.bestellteArt[i].bestellungenId,
                staoId: state.bestellteArt[i].staoId,
                besMax: bestand,
                anzahl: parseInt(state.bestellteArt[i].anzahl),
                eingetroffen: parseInt(state.bestellteArt[i].eingetroffen) + parseInt(state.bestellteArt[i].gekommen),
                gekommen: parseInt(state.bestellteArt[i].gekommen),
                done: state.bestellteArt[i].done
            }
            data.push(stuff);
        }

        console.log(data);

        http.post('/bestellungenAbuchen', data)
            .then((response) => {
                location.reload();
            });
    },

    bestellFiles: ({ commit }, payload) => {
        http.post('/getAllBestellungsFiles', { stao: payload.stao })
            .then((response) => {
                commit('bestellFiles', response.data);
            });
    },

    bestellFilesDownload: ({}, payload) => {
        // download the file
        var url = payload.url + '/downloadFileBestellung/' + payload.fileName;

        // console.log(url);

        window.location.assign(url);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
